import gun from './assets/handguns.jpg'
import rifle from './assets/rifles.jpg'
import optics from './assets/optics.jpg'
import shotgun from './assets/shotgun.jpg'
import ammu from './assets/ammunation.jpg'
import access from './assets/accessories.jpg'
import oz9 from './assets/oz9.jpg'
import oz9c from './assets/oz9c.jpg'
import mp5 from './assets/mp5.jpg'
import norino from './assets/norino.jpg'
import zigana from './assets/oz9.jpg'
import glock from './assets/glock.jpg'
import eagle from './assets/eagle.jpg'
import colt from './assets/colt.jpg'
import beratta from './assets/berreta.jpg'
import mini from './assets/mini14.jpg'
import lr from './assets/lr223.jpg'
import semprio from './assets/semprio.jpg'
import vtr from './assets/vtrjpg.jpg'
import saiga from './assets/saiga.jpg'
import coltCommando from './assets/coltcommando.jpg'
import ar15 from './assets/ar15.jpg'
import aug from './assets/aug.jpg'
import a4 from './assets/a4.png'
import hunter from './assets/hunter.jpg'
import maxus from './assets/maxus.jpg'
import unico from './assets/unico.jpg'
import karatay from './assets/karatay.jpg'
import benelli from './assets/benelli.jpg'
import wood from './assets/wood.jpg'
import action from './assets/action.jpg'
import mag from './assets/mag.jpg'
import luger from './assets/luger.jpg'
import sako308 from './assets/sako308.jpg'
import hornady from './assets/hornady.jpg'
import hammer from './assets/hammer.jpg'
import nexus from './assets/nexus.jpg'
import gr from './assets/gr.jpg'
export const products= [
    {
        id:1,
        name: 'HandGun',
        
        image: gun,
      
        description: 'a Gun designed for use by one hand, especially a Pistol or Revolver.'
    },
    {
        id:2,
        name: 'Rifles',
       
        
        image: rifle,
       
        description: 'a Gun, having a long spirally grooved barrel which have Greater Accuracy over a Long Distance.'
    },
    {
        id:3,
        name: 'Shotguns',
       
        image: shotgun,
       
       
        description: 'a smooth bore Gun for firing small Shot at short range'
    },
    {
        id:4,
        name: 'Ammunition',
       
        
        image: ammu,
       
        description: 'Ammunition is the Material Fired, scattered, dropped or detonated from any Weapon.'
    },
    
]

export const handGuns= [
    {
        id:1,
        name: 'Glock 17 Gen 3', 
        price: 70000,
        image: glock,
      
        description: 'a Gun designed for use by one hand, especially a Pistol or Revolver.'
    },
    {
        id:2,
        name: 'Desert Eagle',
       
        price:200000,
        image: eagle,
       
        description: 'a Gun, having a long spirally grooved barrel which have Greater Accuracy over a Long Distance.'
    },
    {
        id:3,
        name: '9mm Zigana',
        price:150000,
        image: zigana,
       
       
        description: 'a smooth bore Gun for firing small Shot at short range'
    },
    {
        id:4,
        name: 'Beretta 92',
        price:100000,
        
        image: beratta,
       
        description: 'Ammunition is the Material Fired, scattered, dropped or detonated from any Weapon.'
    },
    {
        id:4,
        name: 'Colt Combat',
       
        price:60000,
        image: colt,
        description: 'There is a saying ” Buy a Gun for $1,000 and Buy an Optic for $2,000'
    },

    {
        id:5,
        name: 'MP5',
        price:90000,
        
        image: mp5,
        description: 'Up-gradation Products for your Shooting'
    },
    {
        id:6,
        name: 'ZEV OZ9',
       
        price:50000,
        image: oz9,
        description: 'Up-gradation Products for your Shooting'
    },
    {
    id:7,
    name: 'ZEV OZ9C',
    price:70000,
    
    image: oz9c,
    description: 'Up-gradation Products for your Shooting'
    },
    {
        id:8,
        name: 'Norino 98',
        price:80000,
        
        image: norino,
        description: 'Up-gradation Products for your Shooting'
        },
]

export const rifles= [
    {
        id:6,
        name: 'FN AR-15 A4',
        price:300000,
        
        image: a4,
        description: 'Up-gradation Products for your Shooting'
    },
    {
        id:8,
        name: 'Colt Commando',
        price:600000,
        
        image: coltCommando,
        description: 'Up-gradation Products for your Shooting'
        },
    {
        id:1,
        name: 'ZEV AR15', 
        price:200000,
        image: ar15,
      
        description: 'a Gun designed for use by one hand, especially a Pistol or Revolver.'
    },
    {
        id:2,
        name: 'LR 223',
       
        price:800000,
        image: lr,
       
        description: 'a Gun, having a long spirally grooved barrel which have Greater Accuracy over a Long Distance.'
    },
    {
        id:3,
        name: 'Krieghoff Semprio',
        price:250000,
        image: semprio,
       
       
        description: 'a smooth bore Gun for firing small Shot at short range'
    },
    {
        id:4,
        name: 'Saiga Izhmash 223',
       
        price:100000,
        image: saiga,
       
        description: 'Ammunition is the Material Fired, scattered, dropped or detonated from any Weapon.'
    },
    {
        id:4,
        name: 'Ruger Mini 14',
       
        price:200000,
        image: mini,
        description: 'There is a saying ” Buy a Gun for $1,000 and Buy an Optic for $2,000'
    },

    {
        id:5,
        name: 'Remington Model 700 VTR',
       
        price:550000,
        image: vtr,
        description: 'Up-gradation Products for your Shooting'
    },
   
    {
    id:7,
    name: 'Steyr AUG A1',
   
    price:150000,
    image: aug,
    description: 'Up-gradation Products for your Shooting'
    },
   
]

export const shotguns= [
    {
        id:4,
        name: 'Benelli 12 gauge SL80 Pasion Wood',
        price:100000,
        
        image: wood,
        description: 'There is a saying ” Buy a Gun for $1,000 and Buy an Optic for $2,000'
    },
    {
        id:6,
        name: 'Browning Maxus',
       
        price:90000,
        image: maxus,
        description: 'Up-gradation Products for your Shooting'
    },
    {
        id:8,
        name: 'Browning Gold Hunter',
       
        price:350000,
        image: hunter,
        description: 'Up-gradation Products for your Shooting'
        },
    {
        id:1,
        name: 'Beretta A400 Xplor Action', 
        price:150000,
        image: action,
      
        description: 'a Gun designed for use by one hand, especially a Pistol or Revolver.'
    },
    {
        id:2,
        name: 'Benelli Pasion',
        price:200000,
        
        image: benelli,
       
        description: 'a Gun, having a long spirally grooved barrel which have Greater Accuracy over a Long Distance.'
    },
    {
        id:3,
        name: 'Akkar Karatay',
        price:500000,
        image: karatay,
       
       
        description: 'a smooth bore Gun for firing small Shot at short range'
    },
    {
        id:4,
        name: 'Beretta A400 Xtreme Unico',
       
        price:80000,
        image: unico,
       
        description: 'Ammunition is the Material Fired, scattered, dropped or detonated from any Weapon.'
    },
   
   

  
   
]

export const ammo= [
    {
        id:4,
        name: 'Hornady Custom Lite Ammunition 300 Winchester Magnum 150 Grain SST Box of 20',
       
        price:1000,
        image: hornady,
        description: 'There is a saying ” Buy a Gun for $1,000 and Buy an Optic for $2,000'
    },
    {
        id:6,
        name: 'Winchester 9mm Luger 147 grains',
       
        price:1000,
        image: luger,
        description: 'Up-gradation Products for your Shooting'
    },
    {
        id:8,
        name: '308 Win 150 gr SST® Superformance',
        price:1000,
        
        image: gr,
        description: 'Up-gradation Products for your Shooting'
        },
    {
        id:1,
        name: 'SAKO .270 WIN. – 156GR – HAMMERHEAD', 
        price:1000,
        image: hammer,
      
        description: 'a Gun designed for use by one hand, especially a Pistol or Revolver.'
    },
    {
        id:2,
        name: 'Sako 308 Win HammerHead',
       
        price:1000,
        image: sako308,
       
        description: 'a Gun, having a long spirally grooved barrel which have Greater Accuracy over a Long Distance.'
    },
    {
        id:3,
        name: 'SUPER HAMMERHEAD SAKO. .300 Win. Mag.',
        price:1000,
        image: mag,
       
       
        description: 'a smooth bore Gun for firing small Shot at short range'
    },
    {
        id:4,
        name: 'Nexus Ammunition Ballistic Superiority .300 Win Mag 220gr Match',
       
        price:1000,
        image: nexus,
       
        description: 'Ammunition is the Material Fired, scattered, dropped or detonated from any Weapon.'
    },
   

  
   
]

export const cart = [
    
]